module.exports = __webpack_public_path__ + "img/money-icon.1a030c8.png";